import _ from "lodash";
import * as z from "../../framework";
import { settings } from "../../framework/core/settings";
import { emptyFn } from "../../framework/core/util";
import { originalAjax } from "../../framework/data/ajax";
import { showAjaxResponseMessages } from "../../framework/data/ajaxUtil";
import * as logHelper from "../../framework/dataComponents/logHelper";
import * as core from "./core";
import * as realTimeUpdates from "./util/realTimeUpdates";
import { usingAuth0 } from "./util/util";

// If the logHelper import is not used, then there is a runtime error.
// There is some issue with the imports that is unresolved.
// This should be removed if a solution is found.
var SWPS = logHelper;

export function attachAjaxHandlers() {
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (localStorage.stopAllAjaxRequests === "true" && options.dataType != "text") {

            if ($("#DownTimeWindowAjaxRequestTry").length == 0) {
                z.controls.alert({
                    id: "DownTimeWindowAjaxRequestTry",
                    type: "info",
                    header: z.ll("MaintenanceAlert"),
                    message: z.ll("AllRequestsAreNowBlockedUntilMaintenanceIsFininshed")
                });
            }

            jqXHR.abort();
            return false;
        }

        options.headers = options.headers || {};

        var isCdnRequest = _.includes((options.url || "").toLowerCase(), (__webpack_public_path__ + "content").toLowerCase());
        if (isCdnRequest) {
            return;
        }

        // tslint:disable:no-string-literal
        if (!options.headers["Authorization"]) {
            options.headers["Authorization"] = "Bearer " + localStorage.getItem("IDSBearer");
        }

        if (!options.headers["Company-Version"]) {
            options.headers["Company-Version"] = settings.companyVersion;
        }

        if (!options.headers["CompanyId"]) {
            options.headers["CompanyId"] = settings.CompanyId;
        }

        if (!options.headers["Correlation-Id"]) {
            options.headers["Correlation-Id"] = kendo.guid();
        }

        if (!options.headers["Client-Id"]) {
            options.headers["Client-Id"] = "sp10";
        }

        if (options.enableDeferreds !== true) {
            options.headers["Disable-Deferreds"] = true;
        }
        // tslint:enable:no-string-literal
    });

    $(document).ajaxError(function (event, jqxhr) {
        if (jqxhr.status == 401) {
            var wasNotAuthorized = true;
            core.logout(wasNotAuthorized);
            // TODO: When we have meaningful roles and rights, what if there was just a bug
            // that allowed the user access to some UI that they should not have had access to?
            // We only really want to show the log in screen again if the access token is invalid
        }
        if (jqxhr.status == 503) {
            z.controls.alert({
                header: z.ll("FiveOThree"),
                message: z.ll("FiveOThreeAlertMessage"),
                type: "danger",
                wait: 15000
            });
        }
    });

    $.ajaxPrefilter(function (options) {
        var realTimeUpdateServerUrl = realTimeUpdates.url();
        if (realTimeUpdateServerUrl && options.url.indexOf(realTimeUpdateServerUrl) > -1) {
            return;
        }

        if (options.data) {
            if (options.data.charAt(0) == "{") {
                options.data = $.parseJSON(options.data);

                // tslint:disable-next-line:forin
                for (var key in options.data) {
                    var upperKey = key.toUpperCase();
                    if (options.data.hasOwnProperty(key) && (upperKey.indexOf("DATE") != -1 || upperKey.indexOf("TIME") != -1)) {
                        var item = options.data[key];
                        if (typeof item == "string") {
                            var parse: any = Date.parse(item);
                            var tempDate: any = new Date(item);
                            if (parse != "NaN" && tempDate != "Invalid Date" && (item.length == 17 || item.length == 16)) {
                                options.data[key] = tempDate;
                            }
                        }
                    }
                }

                options.data = JSON.stringify(options.data);
            }
        }

        var urlPrefix = settings.appSettings.urlPrefix || "/service/api/";

        if (options.url.indexOf("service/api") == -1 &&
            options.url.indexOf(".js") == -1 &&
            (!core.identityServerSettings ||
                options.url.indexOf(core.identityServerSettings.authority) != 0)
        ) {
            options.url = urlPrefix + options.url;
        }
    });

    $(document).ajaxSend(function (event, jqxhr) {
        if (settings.appSettings.urlPrefix) {
            jqxhr.setRequestHeader("Access-Control-Allow-Origin", "*");

            jqxhr.setRequestHeader("Access-Control-Allow-Methods", "GET, POST, PUT, DELETE");
            jqxhr.setRequestHeader("Access-Control-Allow-Headers", "Content-Type, Accept");
            jqxhr.setRequestHeader("Access-Control-Max-Age", "1728000");

            jqxhr.setRequestHeader("Access-Control-Allow-Credentials", "true");
        }
    });

    showAjaxResponseMessages();
}

/*
    * ajax
    * Wrapper for $.ajax
    *
    * All jquery ajax options are accepted
    *
    *
    * Defaults:
    * header.Authorization-Token = services token
    * success = function(){}
    * cache = false
    * contentType = "application/json"
    * dataType = "json"
    * overlay = true
    *
*/
export function ajax(options): JQueryPromise<any> {
    options = options || {};

    if (usingAuth0()) {
        const urlPrefix = settings.appSettings.urlPrefix || localStorage.getItem("urlPrefix") || "/service/api/";
        let url;
        if (options.url === undefined) {
            url = undefined;
        } else if ((options.url as string).startsWith("http") ||
            (options.url as string).indexOf(urlPrefix) !== -1
        ) {
            url = options.url;
        } else {
            url = `${urlPrefix}${options.url}`;
        }
        options.url = url;
    }

    var success = options.success || function () {
    };
    options.success = function (data) {
        // TODO: reset session timer or other operation we want to do on each ajax request
        // z.resetSessionTimer();

        // execute callback if present
        success(data);
    };

    if (options.correlationId) {
        options.headers = options.headers || {};
        options.headers["Correlation-Id"] = options.correlationId;
    }

    if (options.correlationGroupId) {
        options.headers = options.headers || {};
        options.headers["Correlation-Group-Id"] = options.correlationGroupId;
    }

    var deferred: any = $.Deferred<any>();

    var errorFn = options.error || emptyFn;
    options.error = function (data, textStatus, errorThrown) {
        if (data.status == 502) {
            ajaxCall.tryCount = 1;
            ajaxCall.errorFn = errorFn;
            ajaxRetry(ajaxCall, deferred);
        } else {
            deferred.reject(data, textStatus, errorThrown);
        }
    };

    var tokenAvailable = false;
    if (localStorage.getItem("IDSBearer")) {
        tokenAvailable = true;
    }

    if (!tokenAvailable) {
        options.errorHandled = true;

        deferred.reject({
            "d": null,
            "Message": "Missing request header key for authorization",
            "Errors": {
                "Validation": [],
                "General": [
                    {
                        "Error": "UnauthorizedException",
                        "Details": "Missing request header key for authorization",
                        "ErrorCode": 20,
                        "InnerException": "",
                        "Data": null,
                        "Source": "SPX.Services"
                    }
                ]
            }
        });
    }

    var ajaxCall = options;

    originalAjax(options)
        .done(function (data, textStatus, jqXHR) {
            deferred.resolve(data, textStatus, jqXHR);
        });

    return deferred.promise();
}

export function ajaxRetry(ajaxCall, deferred) {
    console.log("502 Detected");
    $.wait(2000 * ajaxCall.tryCount).then(function () {
        ajaxCall.error = function (data, textStatus, errorThrown) {
            if (ajaxCall.tryCount <= 5) {
                ajaxCall.tryCount += 1;
                ajaxRetry(ajaxCall, deferred);
            } else {
                ajaxCall.errorFn.apply(this, [data, textStatus, errorThrown]);
                deferred.reject(data, textStatus, errorThrown);
            }
        };
        originalAjax(ajaxCall).done(function (data, textStatus, jqXHR) {
            deferred.resolve(data, textStatus, jqXHR);
        });
    });
}
